import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaCamera,
  FaEnvelope,
  FaShieldAlt,
  FaFileContract,
  FaInfoCircle,
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <FaCamera />
            <span>PhotoMatch</span>
          </Link>
          <p>
            Retrouvez et livrez les photos d'evenements plus vite grace a une
            experience simple pour les participants et les photographes.
          </p>
        </div>

        <div className="footer-links" aria-label="Liens de pied de page">
          <Link to="/about">
            <FaInfoCircle />
            <span>A propos</span>
          </Link>
          <Link to="/contact">
            <FaEnvelope />
            <span>Contact</span>
          </Link>
          <Link to="/privacy">
            <FaShieldAlt />
            <span>Confidentialite</span>
          </Link>
          <Link to="/terms">
            <FaFileContract />
            <span>Conditions</span>
          </Link>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {year} PhotoMatch. Tous droits reserves.</span>
      </div>
    </footer>
  );
};

export default Footer;
